import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Typography } from 'rmwc';
import { Icon } from 'rmwc/Icon';

import { Text } from '../../components/Text';
import { CTAOpt } from '../../components/Onboarding/CtaVariants';

export default class CallToAction extends Component {
  render() {
    return (
      <div className="container-fluid mb-4">
        <Text use="headline5" className="pt-4 mb-2">
          How do you want to get started?
        </Text>
        <div style={{ display: 'flex' }}>
          <CTAOpt
            title="Consult with an Advisor"
            subtitle="A free 30-minute session."
            image={require('images/onboarding-conversation.png')}
            description="Join one of our registered advisors online. They’ll ask a few questions, then walk you through an action plan designed for you."
            buttonText="Get a free consult"
            onClick={() => this.props.history.push(`/start/review-plan`)}
          />
          <CTAOpt
            title="Get started on your own"
            subtitle="For do-it-yourselfers."
            image={require('images/onboarding-diy.png')}
            description="Use our software to explore your recommendations, and put them into action. We'll guide you through every step."
            buttonText="Get started for free"
            onClick={this.props.onContinue}
          />
        </div>
        <div class="mt-3" style={{ display: 'flex', alignItems: 'center' }}>
          <Icon className="mr-1" theme="text-secondary-on-background">
            report
          </Icon>
          <Typography use="body1" theme="text-secondary-on-background">
            No credit card information needed. The planner is completely free to use for life.{' '}
          </Typography>
        </div>
        <Typography use="body1" tag="div" className="mt-2">
          <a href="https://www.harborplan.com/faq#how-make-money">How does Harbor make money?</a>
        </Typography>
      </div>
    );
  }
}
